module.exports = __webpack_public_path__ + "static/img/ppt.32a2012.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icones/ppt.png
// module id = VeDD
// module chunks = 1